










import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcContactTable from '@contacts/components/tables/contact-table/contact-table.vue';

@Component({
  name: 'bpc-club-contacts',
  components: {
    'bpc-contact-table': BpcContactTable,
  },
})
export default class ClubContacts extends Vue {
  /* Lifecycle hooks */
  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
